// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3ZeDx","buttons":"RemoveExpirationActionButtons_buttons__2qXrd"};